module.exports = __webpack_public_path__ + "img/part5-1.6d836f48.png";